import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        NotReadyModal: {};
    }
}

const NotReadyModal: ActivityComponentType<'NotReadyModal'> = () => {
    const { pop } = useFlow();
    return (
        <AppModal confirm='閉じる' onConfirm={pop}>
            <Text size='title' align='center'>
                Androidアプリは<br/>
                現在準備中でございます。<br/>
                今しばらく<br/>
                お待ちくださいませ。
            </Text>
        </AppModal>
    );
};

export default NotReadyModal;
